<template>
  <div class="ready-web">
    <div style="background:rgba(249, 249, 249, 1);">
      <div class="header" id="header">
        <div style="display:flex;justify-content: space-between;">
          <div style="width:5.5rem;padding-top:1rem;">
            <p class="title">{{$t('RedteaReady.title1')}}</p>
            <p class="content">{{$t('RedteaReady.des1')}}</p>
            <p
              style="color: rgba(32, 49, 82, 1);font-family: 'Poppins-Light';font-size: 14px;text-align: left;"
            >
              {{$t('RedteaReady.des2')}}
              <router-link to="/CaaS" style="color:rgba(211, 36, 23, 1);">
                <span>{{$t('RedteaReady.desLink')}}</span>
              </router-link>
              {{$t('RedteaReady.des222')}}
            </p>
          </div>
          <div class="img">
            <img :src="readyImg" style="width:5.5rem;" />
          </div>
        </div>
        <div class="entry-links">
          <a
            href="https://console.redteaready.cn/login"
            target="_blank"
            rel="noopener noreferrer"
          >
            <p class="more">{{$t('RedteaReady.platform')}}</p>
          </a>
          <a href="https://redteaready.cn/" target="blank">
            <p class="more">{{$t('learnMore')}}&nbsp;&nbsp;></p>
          </a>
        </div>
      </div>
    </div>

    <div style="background:rgba(117, 130, 154, 1);">
      <div class="app">
        <p class="title">{{$t('RedteaReady.title2')}}</p>
        <div class="flex-box">
          <div>
            <p class="title-little">{{$t('RedteaReady.app.title1')}}</p>
            <p class="content beforeLine">{{$t('RedteaReady.app.text1')}}</p>
            <p class="content beforeLine">{{$t('RedteaReady.app.text2')}}</p>
            <p class="content beforeLine">{{$t('RedteaReady.app.text3')}}</p>
          </div>
          <div>
            <p class="title-little">{{$t('RedteaReady.app.title2')}}</p>
            <p class="content beforeLine">{{$t('RedteaReady.app.text4')}}</p>
            <p class="content beforeLine">{{$t('RedteaReady.app.text5')}}</p>
            <p class="content beforeLine">{{$t('RedteaReady.app.text6')}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="earth">
      <img :src="readyImg1" />
      <!-- <p class="title">{{$t('RedteaReady.title3')}}</p> -->
    </div>

    <div class="img-box">
      <img src="../assets/ready-web/1.png" />
      <p class="title" id="FWA">{{$t('RedteaReady.fwa.title')}}</p>
      <p class="content">{{$t('RedteaReady.fwa.des')}}</p>
      <div class="before-box">
        <p class="content" style="margin-top: 0.2rem">{{$t('RedteaReady.fwa.title1')}}</p>
        <p class="content box-img1">{{$t('RedteaReady.fwa.text1')}}</p>
      </div>
      <div class="before-box">
        <p class="content" style="margin-top: 0.2rem">{{$t('RedteaReady.fwa.title2')}}</p>
        <p class="content box-img2" style="margin-bottom:1.2rem;">{{$t('RedteaReady.fwa.text2')}}</p>
      </div>
      <img src="../assets/ready-web/2.png" />
      <p class="title" id="Automotive">{{$t('RedteaReady.auto.title')}}</p>
      <p class="content">{{$t('RedteaReady.auto.des')}}</p>
      <div class="before-box">
        <p class="content" style="margin-top: 0.2rem">{{$t('RedteaReady.auto.title1')}}</p>
        <p class="content box-img3">{{$t('RedteaReady.auto.text1')}}</p>
      </div>
      <div class="before-box">
        <p class="content" style="margin-top: 0.2rem">{{$t('RedteaReady.auto.title2')}}</p>
        <p class="content box-img4" style="margin-bottom:1.2rem;">{{$t('RedteaReady.auto.text2')}}</p>
      </div>
      <img src="../assets/ready-web/3.png" />
      <p class="title" id="Handheld">{{$t('RedteaReady.hand.title')}}</p>
      <p class="content">{{$t('RedteaReady.hand.des')}}</p>
      <div class="before-box">
        <p class="content" style="margin-top: 0.2rem">{{$t('RedteaReady.hand.title1')}}</p>
        <p class="content box-img5">{{$t('RedteaReady.hand.text1')}}</p>
      </div>
      <div class="before-box">
        <p class="content" style="margin-top: 0.2rem">{{$t('RedteaReady.hand.title2')}}</p>
        <p class="content box-img6">{{$t('RedteaReady.hand.text2')}}</p>
      </div>
      <div class="before-box">
        <p class="content" style="margin-top: 0.2rem">{{$t('RedteaReady.hand.title3')}}</p>
        <p class="content box-img7" style="margin-bottom:1.2rem;">{{$t('RedteaReady.hand.text3')}}</p>
      </div>
      <img src="../assets/ready-web/4.png" />
      <p class="title" id="Logistics">{{$t('RedteaReady.log.title')}}</p>
      <div class="before-box">
        <p class="content box-img8" style="margin-bottom:1.2rem;">{{$t('RedteaReady.log.des')}}</p>
      </div>
      <img src="../assets/ready-web/5.png" />
      <p class="title" id="Utilities">{{$t('RedteaReady.uti.title')}}</p>
      <p class="content">{{$t('RedteaReady.uti.des')}}</p>
      <div class="before-box">
        <p class="content" style="margin-top: 0.2rem">{{$t('RedteaReady.uti.title1')}}</p>
        <p class="content box-img9">{{$t('RedteaReady.uti.text1')}}</p>
      </div>
      <div class="before-box">
        <p class="content" style="margin-top: 0.2rem">{{$t('RedteaReady.uti.title2')}}</p>
        <p class="content box-img10" style="margin-bottom:1.2rem;">{{$t('RedteaReady.uti.text2')}}</p>
      </div>
      <img src="../assets/ready-web/6.png" />
      <p class="title" id="Wearable">{{$t('RedteaReady.wear.title')}}</p>
      <div class="before-box">
        <p class="content box-img11">{{$t('RedteaReady.wear.des')}}</p>
      </div>
    </div>

    <div style="background:rgba(249, 249, 249, 1);">
      <div class="brand">
        <p class="title">{{$t('RedteaReady.brands.title')}}</p>
        <div class="box" style="margin-bottom:30px;">
          <img src="../assets/ready-web/设备3web.png" />
          <div>
            <p class="little-title">{{$t('RedteaReady.brands.title1')}}</p>
            <p class="content">{{$t('RedteaReady.brands.text1')}}</p>
          </div>
        </div>

        <div class="box" style="margin-bottom:30px;">
          <img src="../assets/ready-web/设备2web.png" />
          <div>
            <p class="little-title">{{$t('RedteaReady.brands.title2')}}</p>
            <p
              style="color: rgba(32, 49, 82, 1);font-family: 'Poppins-Light';font-size: 14px;text-align: left;"
            >{{$t('RedteaReady.brands.text2')}}</p>
          </div>
        </div>

        <div class="box" style="margin-bottom:30px;">
          <img src="../assets/ready-web/设备1web.png" />
          <div>
            <p class="little-title">{{$t('RedteaReady.brands.title3')}}</p>
            <p class="content">{{$t('RedteaReady.brands.text3')}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RedteaReady-web',
  components: {},
  computed: {
    readyImg() {
      return this.$store.state.readyImg
    },
    readyImg1() {
      return this.$store.state.readyImg1
    }
  }
}
</script>
<style lang="less" scoped>
.ready-web {
  .header {
    width: 11.8rem;
    margin: auto;
    padding: .8rem 0;
    .title {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-Light';
      font-size: 0.35rem;
      text-align: left;
      // margin-top: 1rem;
    }
    .content {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-Light';
      font-size: 14px;
      text-align: left;
      margin-top: 0.1rem;
    }
  }
  .app {
    width: 70%;
    margin: auto;
    padding: 1.2rem 0;
    .title {
      color: rgba(255, 255, 255, 1);
      font-family: 'Poppins-Light';
      font-size: 0.35rem;
    }
    .title-little {
      color: rgba(255, 255, 255, 1);
      font-family: 'Poppins-Light';
      font-size: 20px;
      text-align: left;
      margin: 0.56rem 0 0.16rem 0;
    }
    .flex-box {
      display: flex;
      justify-content: space-between;
    }
    .content {
      color: rgba(255, 255, 255, 0.8);
      font-family: 'Poppins-Light';
      font-size: 14px;
      text-align: left;
    }
  }
  .earth {
    .title {
      color: rgba(255, 255, 255, 1);
      font-family: 'Poppins-Light';
      font-size: 0.3rem;
      margin-top: -0.8rem;
    }
  }
  .img-box {
    width: 11.8rem;
    margin: auto;
    padding: 1.2rem 0;
    .title {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-Regular';
      font-size: 0.2rem;
      text-align: left;
      margin: 0.2rem 0;
    }
    .content {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-Light';
      font-size: 14px;
      text-align: left;
    }
  }
  .brand {
    width: 11.8rem;
    margin: auto;
    padding: 1.2rem 0;
    .box {
      display: flex;
      align-items: center;
      img {
        width: 1.5rem;
        margin-right: 0.5rem;
        height: 100%;
      }
    }
    .title {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-Light';
      font-size: 30px;
      margin-bottom: 50px;
    }
    .little-title {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-Regular';
      font-size: 20px;
      text-align: left;
      margin-bottom: 10px;
    }
    .content {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-Light';
      font-size: 14px;
      text-align: left;
    }
  }
  .before-box {
    position: relative;
    .content {
      margin-left: 1.28rem;
    }
  }
  .box-img1:before {
    background-image: url('../assets/ready-web/CPE@3x.png');
    content: '';
    background-size: 0.88rem 0.38rem;
    position: absolute;
    width: 0.88rem;
    height: 0.38rem;
    left: 10px;
  }
  .box-img2:before {
    background-image: url('../assets/ready-web/Ads Player @3x.png');
    content: '';
    background-size: 0.88rem 0.38rem;
    position: absolute;
    width: 0.88rem;
    height: 0.38rem;
    left: 10px;
  }
  .box-img3:before {
    background-image: url('../assets/ready-web/IVI@3x.png');
    content: '';
    background-size: 0.88rem 0.38rem;
    position: absolute;
    width: 0.88rem;
    height: 0.38rem;
    left: 10px;
  }
  .box-img4:before {
    background-image: url('../assets/ready-web/Rearview Mirror @3x.png');
    content: '';
    background-size: 0.88rem 0.38rem;
    position: absolute;
    width: 0.88rem;
    height: 0.38rem;
    left: 10px;
  }
  .box-img5:before {
    background-image: url('../assets/ready-web/POS Machine @3x.png');
    content: '';
    background-size: 0.88rem 0.38rem;
    position: absolute;
    width: 0.88rem;
    height: 0.38rem;
    left: 10px;
  }
  .box-img6:before {
    background-image: url('../assets/ready-web/AI translator @3x.png');
    content: '';
    background-size: 0.88rem 0.38rem;
    position: absolute;
    width: 0.88rem;
    height: 0.38rem;
    left: 10px;
  }
  .box-img7:before {
    background-image: url('../assets/ready-web/Mi-Fi @3x.png');
    content: '';
    background-size: 0.88rem 0.38rem;
    position: absolute;
    width: 0.88rem;
    height: 0.38rem;
    left: 10px;
  }
  .box-img8:before {
    background-image: url('../assets/ready-web/Tracker@3x.png');
    content: '';
    background-size: 0.88rem 0.38rem;
    position: absolute;
    width: 0.88rem;
    height: 0.38rem;
    left: 10px;
    top: 10px;
  }
  .box-img9:before {
    background-image: url('../assets/ready-web/Intelligent Lock System @3x.png');
    content: '';
    background-size: 0.88rem 0.38rem;
    position: absolute;
    width: 0.88rem;
    height: 0.38rem;
    left: 10px;
  }
  .box-img10:before {
    background-image: url('../assets/ready-web/Smart Metering @3x.png');
    content: '';
    background-size: 0.88rem 0.38rem;
    position: absolute;
    width: 0.88rem;
    height: 0.38rem;
    left: 10px;
  }
  .box-img11:before {
    background-image: url('../assets/ready-web/智能手表@3x.png');
    content: '';
    background-size: 0.88rem 0.38rem;
    position: absolute;
    width: 0.88rem;
    height: 0.38rem;
    left: 10px;
    top: 10px;
  }
  .entry-links {
    display: flex;
    align-items: center;
    margin-top: 0.4rem;
    a + a {
      margin-left: 0.28rem;
    }
  }
  .more {
    color: rgba(207, 42, 42, 1);
    font-family: 'Poppins-Light';
    font-size: 20px;
    text-align: left;
    text-decoration: underline;
    margin: 0;
    // padding-bottom: 1rem;
  }
}
</style>
